module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Italic.1c343248.otf";